import _startCase from 'lodash/startCase';
import type { DropdownItemProps } from 'semantic-ui-react';

import {
  VexJustification,
  VexStatus,
} from '@features/applications/applications.models';

export const VEX_STATUS_OPTIONS: DropdownItemProps[] = [
  // SUI's `DropdownItemProps['value']` rejects `null` at the type level even
  // though it accepts it at runtime; the cast preserves our `null` sentinel
  // through the form/RHF round-trip.
  { key: 'none', text: 'None', value: null as unknown as undefined },
  ...Object.values(VexStatus).map(value => ({
    key: value,
    text: _startCase(value),
    value,
  })),
];

export const VEX_JUSTIFICATIONS = Object.values(VexJustification).map(
  value => ({
    key: value,
    text: _startCase(value),
    value,
  }),
);
